import { IPagination } from "@/models/Pagination";
export const paginationDefault: IPagination = {
  last_page: 1,
  current_page: 1,
  to: 1,
  from: 1,
  per_page: 20,
  total: 1
};